import { render, staticRenderFns } from "./AddNewButton.vue?vue&type=template&id=3acc3b1a"
import script from "./AddNewButton.vue?vue&type=script&lang=js"
export * from "./AddNewButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports